import { AdminApproved } from "api";

export interface IApproval {
    allowed: boolean;
    mustApprove: boolean;
    optionalMessage: string;
    adminApproved: AdminApproved;
}

const INITIAL_STATE: IApproval = {
    allowed: false,
    mustApprove: false,
    optionalMessage: "",
    adminApproved: AdminApproved.None
}

const Approval = (state = INITIAL_STATE, action: { type: string, payload: any }): IApproval => {
    switch (action.type) {
        case 'SET_ALLOWED':
            state = {
                ...state,
                allowed: action.payload
            }
            break;
        case 'SET_MUST_APPROVE':
            state = {
                ...state,
                mustApprove: action.payload
            }
            break;
        case 'SET_OPTIONAL_MESSAGE':
            state = {
                ...state,
                optionalMessage: action.payload
            }
            break;
        case 'SET_ADMIN_APPROVED':
            state = {
                ...state,
                adminApproved: action.payload
            }
            break;
        case 'RESET_APPROVAL':
            state = {
                ...state,
                adminApproved: INITIAL_STATE.adminApproved,
                allowed: INITIAL_STATE.allowed,
                mustApprove: INITIAL_STATE.mustApprove,
                optionalMessage: INITIAL_STATE.optionalMessage
            }
            break;
    }
    return state;
}

export default Approval;